import { Component, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonService } from 'src/app/common/common.service';

@Component({
  selector: 'app-attendance-comp',
  templateUrl: './attendance-comp.component.html',
  styleUrls: ['./attendance-comp.component.scss'],
})
export class AttendanceCompComponent implements OnInit {

  public attendance = [];
  batchId: any;
  timetable = [];
  viewTitleAttendance;

  attendanceCalendar = {
    mode: 'month',
    currentDate: new Date()
  };
  eventSourceAttendance: any = [];

  onviewTitleAttendanceChanged(title) {
    this.viewTitleAttendance = title;
  }

  constructor(
    private service: CommonService,
    private router: Router,
    public navCtrl: NavController,
    private route: ActivatedRoute) {
    }

  ngOnInit() {

    this.batchId = 1850;
    const user = JSON.parse(localStorage.getItem('currentUser'));
    this.service.getAttendence(user.student_id, this.batchId, user.branch_id).subscribe((result) => {
      this.attendance = result.Items.reverse();
      console.log(this.attendance);
      let color = '';

      this.attendance.forEach(item => {
        var start = new Date(item.date_time).getTime();
        const obj = {
          title: item.attendance_status,
          startTime: new Date(new Date(start).setHours(0, 0, 0, 0)),
          endTime: new Date(new Date(start).setHours(0, 0, 0, 0)),
          allDay: false,
          eventColor: color
        };
        this.timetable.push(obj);
      })


      for(let i=0; i <= 11; i++){
        this.getDaysInMonth(i, new Date().getFullYear()).forEach(element => {
          const obj = {
            title: '',
            startTime: element,
            endTime: element,
            allDay: false
          };
          this.timetable.push(obj);
  
        });
      }

      var arr = this.timetable.filter((value, index, self) =>
      index === self.findIndex((t) => (
        t.startTime.toString() === value.startTime.toString()
      )))
      console.log(arr)

      this.eventSourceAttendance = arr;
      
    });
  }

  getDaysInMonth(month, year) {
    var date = new Date(year, month, 1);
    console.log(date.getMonth())
    var days = [];
    while (date.getMonth() === month) {
      days.push(new Date(date));
      date.setDate(date.getDate() + 1);
    }
    return days;
  }

  
  back() {
    this.navCtrl.back();
  }

}

